function Maldives({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1586)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M5.56519 8.34766H26.4347V23.652H5.56519V8.34766Z" fill="#6DA544"/>
  <path d="M18.5767 20.5216C16.0794 20.5216 14.0549 18.4971 14.0549 15.9998C14.0549 13.5026 16.0794 11.4781 18.5767 11.4781C19.3553 11.4781 20.088 11.6749 20.7276 12.0216C19.7242 11.0403 18.352 10.4346 16.8375 10.4346C13.764 10.4346 11.2723 12.9262 11.2723 15.9998C11.2723 19.0733 13.764 21.5649 16.8375 21.5649C18.352 21.5649 19.7242 20.9593 20.7276 19.9779C20.088 20.3247 19.3553 20.5216 18.5767 20.5216Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Maldives;
